import { AppContext } from "@lightspeed-invoicing/core-client/frontend"
import React, { useState } from "react"
import { Modal } from "react-bootstrap"
import { FormattedMessage } from "react-intl"
import { isError } from "../../../../state/helpers/Error"
import ListingHelper from "../../../../state/listing/ListingHelper"
import { ObjectType } from "../../../../state/listing/generic-listing"
import { SearchPayload } from "../../../../state/search/SearchPayload"
import EventBus from "../../../EventBus"
import ActionButton from "../../../button/actionbutton.component"
import Icon from "../../../icon/icon.component"

interface OwnProps {
    exportType: ObjectType
    filters: SearchPayload
}

const GenericExportModal = (props: OwnProps) => {
    const [show, setShow] = useState<boolean>(false)

    const handleStart = async () => {
        const res = await ListingHelper.batchExport(props.exportType, props.filters)

        if (!isError(res)) {
            EventBus.dispatch(EventBus.TopicSendSuccessNotification, {
                message: <FormattedMessage
                    id="generic-listing.export-modal.created-message"
                    defaultMessage="Export started successfully. A CSV export will be sent to {email}"
                    values={{
                        email: <strong>{AppContext.getUserLoggedIn().attributes.email}</strong>
                    }}
                />
            })
        }

        setShow(false)
    }

    return (
        <>
            <button
                onClick={() => setShow(true)}
                className="btn btn-sm btn-secondary"
            >
                <Icon value='file-export' className='mr-1' />
                <FormattedMessage
                    id="generic-listing.export-all"
                    defaultMessage="Export all results"
                />
            </button>

            <Modal show={show} onHide={() => setShow(false)} centered>
                <Modal.Body>
                    <p className="p-2 text-left">
                        <FormattedMessage
                            id="generic-listing.export-modal.export-message"
                            defaultMessage={
                                "Your export will be sent to {email} as a CSV file and can take a few minutes to create. Do you want to proceed?"
                            }
                            values={{
                                email: <strong>{AppContext.getUserLoggedIn().attributes.email}</strong>
                            }}
                        />
                    </p>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary" onClick={() => setShow(false)}>
                        <FormattedMessage
                            id="invoice.void_modal.close_btn"
                            defaultMessage="Close"
                        />
                    </button>
                    <ActionButton
                        type="button"
                        className="btn btn-primary"
                        onClick={handleStart}
                    >
                        <FormattedMessage
                            id="invoice.modal.export.start_btn"
                            defaultMessage="Start export"
                        />
                    </ActionButton>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default GenericExportModal


// WEBPACK FOOTER //
// ./src/common/listing/generic-listing/export-modals/GenericExportModal.tsx